import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GuestService, JWT_SERVICE } from '@core/services';
import { AccessDeniedPath } from '@core/constants';

/**
 * The guestGuard looks at the user's guestType to determine if the guest should be allowed to view this route.
 *
 * When using this guard, a "guestType" should be specified in the routeData. For example:
 *
 * `canActivate: [guestGuard],`
 *
 * `data: { guestType: 'THERAPIST' },`
 *
 * Ideally, the guestResolver has been run prior so that the guestType is available.
 */
export const guestGuard: CanActivateFn = (route) => {
  const _router = inject(Router);
  const _guest = inject(GuestService);
  const jwtService = inject(JWT_SERVICE);
  const guestType = route.data.guestType;

  // Most routes have no guestType requirement — skip the JWT decode entirely
  // rather than attempting one that's guaranteed to be irrelevant.
  if (guestType === undefined) {
    return true;
  }

  const guestFromJWT = jwtService.getJwtData();

  if (guestFromJWT?.userType === guestType) {
    return true;
  } else {
    _guest.clearSession();
    _router.navigate([AccessDeniedPath]);

    return false;
  }
};
